export const aa = GRAPHQL_ENDPOINT;
export const SERVER_BASE_URL = API_URL;

export function authorize() {
  return `Bearer ${localStorage.getItem('user.token')}`;
}
